import type { OwlHourSlip } from "../../owl/useOwlHourSlips.ts";
import { useOwlPublicationStates, owlPublicationLabel } from "../../owl/useOwlPublicationStates.ts";

export function OwlPipelineStatusStrip({ slips, loading, error }: {
  slips: readonly OwlHourSlip[]; loading: boolean; error: string | null;
}): JSX.Element {
  const states = useOwlPublicationStates();
  const tiers = new Set(slips.map((slip) => slip.tier)).size;
  return (
    <div role="status" style={{ display: "flex", justifyContent: "space-between", gap: 12,
      flexWrap: "wrap", padding: "12px 14px", marginBottom: 16, borderBottom: "1px solid var(--owl-border)",
      color: "var(--owl-text-2)", fontSize: 12 }}>
      <span>{error ? "Publication unavailable" : loading && !slips.length ? "Loading publications" : `${tiers} of 5 tiers published`}</span>
      <span>Preparation 12:00 / 17:00 · Kickoffs 19:00–07:00 Accra</span>
      {states.length>0 && <div style={{ flexBasis: "100%", display: "flex", gap: 16, flexWrap: "wrap" }}>
        {states.map((entry) => <span key={entry.tier}>{entry.tier.replaceAll("_", " ").toUpperCase()}: {owlPublicationLabel(entry)}</span>)}
      </div>}
    </div>
  );
}
